<template>
  <input :type="type || 'text'"
         @keydown.enter="(e)=> $emit('enter-key-down', e)"
         class="input"
         @input="(e) => $emit('change', e.target.value)"
         :placeholder="placeholder"
         :value="defaultValue"
  >
</template>

<script>
export default {
  name: 'Input',
  emits: ['change', 'enter-key-down'],
  props: ['placeholder', 'defaultValue', 'type'],
}
</script>

<style scoped>
.input {
  width: 100%;
  height: 2.50rem;
  border: 1px solid rgb(156 163 175 / 0.55);
  
  outline: none;
  background-color: white;
  color: #858796;
  @apply px-2
}

.input:focus {
  border: 1px solid #919191;
}
</style>
